import { render } from "./LogViewer.vue?vue&type=template&id=2104b888"
import script from "./LogViewer.vue?vue&type=script&setup=true&lang=js"
export * from "./LogViewer.vue?vue&type=script&setup=true&lang=js"

import exportComponent from "/home/forge/retail.digitalhq.com/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"resources/admin/ui/Components/Common/LogViewer.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "2104b888"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('2104b888', __exports__)) {
    api.reload('2104b888', __exports__)
  }
  
  module.hot.accept("./LogViewer.vue?vue&type=template&id=2104b888", () => {
    api.rerender('2104b888', render)
  })

}


export default __exports__